module.exports = __webpack_public_path__ + "static/gothic-a1-v8-latin-500-ce53dede7193bdf37322fffc4e5592f7.woff";